import { Form } from "antd";
import { HeaderOverview, IRenderLineChart, RenderLineChart } from "components";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  checkData,
} from "pages/overview";
import { useAppLanguage } from "providers/app-language";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetDashboardNewsCountPerMonth } from "service/dashboard/central/news-and-announcement";
import { IData } from "service/dashboard/interface";
import styled from "styled-components";
import tw from "twin.macro";

const WrapperList = styled.div`
  ${tw`bg-white h-full rounded-app p-3`}
`;

const CountPerMonth = () => {
  const { t } = useTranslation();
  const { formatDate } = useAppLanguage();
  const { findDate, property } = useOverview();

  const newsDate = Form.useWatch("newsDate");
  const date = findDate(newsDate, "year");

  const { data, isFetching, isError, error } = useGetDashboardNewsCountPerMonth(
    { ...date, property }
  );

  if (isFetching) {
    return (
      <WrapperList>
        <LoadingDashboard loading={isFetching}>
          <div className="px-4 pt-4">
            <HeaderOverview
              title={t("news-times-year")}
              name="newsDate"
              formatDate="year"
            />
          </div>
          <div className="h-[230px]"></div>
        </LoadingDashboard>
      </WrapperList>
    );
  }

  const findData = checkData(data);

  const getData: IData[] =
    findData?.map((e) => {
      const month = formatDate({ date: e.month, format: "month" });
      return { name: month, count: e?.count || 0 };
    }) || [];

  const dataLine: IRenderLineChart = {
    data: getData,
    dataKeyX: "name",
    dataKeyY: "count",
    height: 230,
  };

  return (
    <WrapperList>
      <div className="px-4 pt-4">
        <HeaderOverview
          title={t("news-times-year")}
          name="newsDate"
          formatDate="year"
        />
      </div>
      {isError ? (
        <ErrorDashboard error={error} height="230px" />
      ) : !findData || findData.length <= 0 ? (
        <NoDataDashboard height="230px" />
      ) : (
        <RenderLineChart {...dataLine} />
      )}
    </WrapperList>
  );
};

export default CountPerMonth;
